import validateColor from 'validate-color';
import { gradientColorVariant, valueIsGradientColor } from './gradientColor';
const addManualValue = (boxColors, valueName, value) => {
    if (value && valueIsGradientColor(value)) {
        if (!(valueName === 'borderColor' && !boxColors.backgroundColor)) {
            return Object.assign(Object.assign({}, boxColors), { [valueName]: gradientColorVariant[value] });
        }
    }
    if (value && validateColor(value)) {
        let formattedValue = `linear-gradient(${value}, ${value})`;
        // in case we have an undefined background color, we have to stick with plain color for the border
        if (valueName === 'borderColor' && !boxColors.backgroundColor) {
            formattedValue = value;
        }
        return Object.assign(Object.assign({}, boxColors), { [valueName]: formattedValue });
    }
    return boxColors;
};
export const getBoxColorProps = ({ colorSet, colors, theme, shadowElevation, backgroundColor, borderColor, }) => {
    let boxColors = {
        borderColor: colors.border,
    };
    if (colorSet) {
        boxColors = {
            borderColor: `linear-gradient(${colors.border}, ${colors.border})`,
            backgroundColor: `linear-gradient(${colors.background}, ${colors.background})`,
        };
    }
    if ((!colorSet || colorSet === 'default') && shadowElevation) {
        boxColors = {
            borderColor: `linear-gradient(${colors.border}, ${colors.border})`,
            backgroundColor: `linear-gradient(${theme.colors.background.overlay}, ${theme.colors.background.overlay})`,
        };
    }
    boxColors = addManualValue(boxColors, 'backgroundColor', backgroundColor);
    boxColors = addManualValue(boxColors, 'borderColor', borderColor);
    return boxColors;
};
